import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../../shared/services/user/user.service";

declare var $: any;

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    token: any;
    person: any;
    isActive: boolean;
    collapsed: boolean;
    showMenu: string;
    pushRightClass: string;
    isSwitchUser: any;
    @Output() collapsedEvent = new EventEmitter<boolean>();
    currentApplicationDetails: any;
    constructor(private toastr: ToastrService,
        private userService: UserService,
        public router: Router) {
        this.router.events.pipe(
            filter((event: RouterEvent) => event instanceof NavigationEnd)
        ).subscribe((data: any) => {
            this.token = localStorage.getItem('token');
            this.person = JSON.parse(localStorage.getItem('person'));
            if (this.person && this.person.role === 'User') {
                this.currentApplicationDetails = this.person.data.find(x => x.isAdditionalLicence === false);
                // console.log(this.currentApplicationDetails);
            }
            this.isSwitchUser = localStorage.getItem('isSwitchUser');
            if (this.isSwitchUser === 'true') {
                $(".switchUserSide").addClass("switchUserSidebar");
            } else {
                $(".switchUserSide").removeClass("switchUserSidebar");
            }
        });
        this.router.events.subscribe(val => {
            if (
                val instanceof NavigationEnd &&
                window.innerWidth <= 992 &&
                this.isToggled()
            ) {
                this.toggleSidebar();
            }
        });
    }

    listGroup() {
        $("body").removeClass("push-right");
    }

    ngOnInit() {
        this.isActive = false;
        this.collapsed = false;
        this.showMenu = '';
        this.pushRightClass = 'push-right';
        this.getDashboardData();
    }

    getDashboardData() {
        this.userService.getUserDashboardDataService(this.token).subscribe((data: any) => {
            this.token = localStorage.getItem('token');
            this.person = data;
            if (this.person.role === 'User') {
                this.currentApplicationDetails = this.person.data.find(x => x.isAdditionalLicence === false);
            }
            this.isSwitchUser = localStorage.getItem('isSwitchUser');
        }, error => {
            if (error.status === 200) {
                return;
            } else if (error.status === 401) {
                localStorage.clear();
                this.toastr.success(error.error.message);
                this.router.navigate(['/signout']);
            } else {
                this.toastr.error(error.message);
            }
        });
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }
}
